import React, { useEffect, useState, forwardRef } from "react";
import { Header } from "../../components/Header/Header";
import { Navigator } from "../../components/Navigator/Navigator";
import photo from "../../assets/Profile/Profile-IMG.png";
import { CustomInput } from "../../components/CustomInput";
import { api } from "../../context/Auth";
import img from "../../assets/Profile/img.png";
import addIcon from "../../assets/Home/icon-plus.svg";
import alertIcon from "../../assets/Home/alert-icon.svg";
import closeIcon from "../../assets/Profile/XIcon.svg";
import { Modal } from "../../components/Modal";
import { AddCSV } from "../../components/AddCSV";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import axios from "axios";
import { ModalAddPP } from "../../components/ModalAddPP";
import { ProfileLoader } from "../../components/SkeletonLoaders/ProfileLoader";
import { Alert } from "../../components/Alert";
import { EnterpriseInfo } from "./EnterpriseInfo";
// import { NemuProfile } from "./NemuProfile";

const TextInputWithLimit = forwardRef(
  ({ characterLimit, textInput, ...props }, ref) => {
    return (
      <div style={{ width: "100%" }} className="">
        <textarea
          ref={ref} // Pasa el ref a la etiqueta textarea
          style={{
            border: "1px solid #B5B5B5",
            resize: "none",
            width: "100%",
            padding: "12px",
            borderRadius: "4px",
            placeholder: "#b5b5b5",
          }}
          rows="5"
          cols="50"
          maxLength={characterLimit} // Límite de caracteres
          placeholder={textInput}
          {...props} // Pasa otras propiedades como `onChange` o `value`
        />
      </div>
    );
  }
);

function Profile() {
  const {
    enterprise,
    loading,
    user,
    acknowledge,
    setAcknowledge,
    updateProfileEnterprise,
    getProfileAcknowledge,
    updateNemuProfile,
    count,
    paymentPlans,
    setPaymentPlans,
  } = useAuth(); // Obtén la función de registro desde el contexto

  let userid;
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm();

  const [activeTab, setActiveTab] = useState(1);
  const [text1, setText1] = useState(""); // Estado para el primer texto (límite 400)
  const [preview, setPreview] = useState(photo);
  const [userId, setUserId] = useState(userid);
  const [openModalPP, setOpenModalPP] = useState(false);
  const [profile_picture, setProfilePicture] = useState(null);
  const [coverPage, setCoverPage] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [deletePlan, setDeletePlan] = useState(null);
  const api = process.env.REACT_APP_API_URL;

   // Función para abrir el modal
   const openModalPPHandler = () => {
    setSelectedPlan(null);
    setOpenModalPP(true);
  };

  // Función para cerrar el modal
  const closeModalPPHandler = () => {
    setOpenModalPP(false);
  };


  const handleChange1 = (e) => {
    if (e.target.value.length <= 400) {
      setText1(e.target.value);
    }
  };

  const fetchProfileAcknowledge = async (id) => {
    try {
      const response = await getProfileAcknowledge(id);
      // console.log(response);
      setAcknowledge(response);
      
    } catch (error) {
      console.error("Error al obtener el perfil de la empresa:", error);
    }
  };


  useEffect(() => {
    // console.log(loading);
    // console.log(enterprise);
    if (enterprise) {
      // console.log("Enterprise");
      // console.log(enterprise);
      // console.log("User");
      // console.log(user);
      // console.log("User ID");
      setUserId(user.id);
      //console.log(userid);
      //  console.log("Cover Page");
      if (enterprise.profile_picture) {
        setPreview(api + "/" + enterprise.profile_picture);
      } else {
        setPreview(photo);
      }

      if (enterprise.profile.cover_page) {
        setCoverPage(api + "/" + enterprise.profile.cover_page);
        // console.log(api + "/" + enterprise.profile.cover_page);
        
      } else {
        setCoverPage(photo);
      }
      setValue("descripcion", enterprise.profile.descripcion); // Establece el valor inicial
      fetchProfileAcknowledge(user.id);
    }
  }, [enterprise, setValue]);

  const handleEdit = (plan) => () => {
    setSelectedPlan(plan);
    setOpenModalPP(true);
  };

  const handleDeletePP = async (id) => {
    // console.log(api);
    try {
      const response = await axios.delete(`${api}/paymentplan/delete/${id}`);
      setPaymentPlans(paymentPlans.filter((plan) => plan.id !== id));
      setDeletePlan(null);
      alert("Plan de pago eliminado");
    }
    catch(error){
      console.error("Error al eliminar el plan de pago:", error);
      alert("Error al eliminar el plan de pago");
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      // Mostrar preview
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);

      // Preparar y enviar la imagen
      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.patch(
          `${api}/user/update-picture/${user.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "¡Imagen actualizada!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.error("Error al actualizar la imagen:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar la imagen",
          showConfirmButton: true,
        });
      }
    }
  };

  return (
    <main className="w-[100vw] max-w-[100vw] bg-[#eaeaea]">
      <Header />
      <div className="flex w-full pr-[20px] pb-[20px] ">
        <Navigator />
        {loading ? (
          //LOADER
          <ProfileLoader/>
          //LOADER
        ) : (
          <div className="grid grid-cols-[1fr_3fr] h-[calc(100svh-120px)] w-full gap-[10px]">
            <div className="flex flex-col gap-[2px] max-h-[calc(100vh-120px)] overflow-y-auto">
              <div className="w-full bg-white p-[8px] h-min rounded-[4px]">
                <div className="flex flex-col gap-[10px] ">
                  {enterprise.profile.profile_picture ? (
                    <div className="relative group">
                      <img
                        className="w-full"
                        src={coverPage}
                        alt="photo_profile"
                      />
                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                        <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={(e) => console.log("Hola")}
                          />
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="relative group">
                      <img
                        className="w-full hover:opacity-80 transition-opacity"
                        src={preview || photo}
                        alt="photo_profile"
                      />

                      {/* Overlay con ícono de cámara al hover */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                        <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={handleImageChange}
                          />
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col gap-[4px]">
                    <h1 className="text-[24px]" onClick={() => console.log(acknowledge)}>
                      {enterprise.enterprise.name}
                    </h1>
                    <span className="text-[12px]">
                      {enterprise.enterprise.address}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                <h1 className="text-[20px] ">Número de proyectos</h1>
                <h1 className="text-[20px]">{count}</h1>
              </div>
              <div className="flex flex-col w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                <span className="text-[12px]">Miembro de Nemu desde</span>
                {new Date(enterprise.createdAt).toLocaleDateString()}
              </div>
            </div>
            
            <div className="flex flex-col w-full h-min py-8 px-6 bg-white rounded-[4px] gap-[20px] max-h-[calc(100vh-120px)] overflow-y-auto">
              <ul className="flex gap-1">
                <li
                  onClick={() => setActiveTab(1)}
                  className={`cursor-pointer m-[10px] pb-1 border-b-2 hover:scale-[1.05] transition-all duration-200  ${
                    activeTab === 1
                      ? "border-nemu-azul text-black"
                      : "border-transparent text-nemu-plata"
                  }`}
                >
                  <span>Información de empresa</span>
                </li>
                {/* <li
                  onClick={() => setActiveTab(2)}
                  className={`cursor-pointer m-[10px] pb-1 border-b-2 hover:scale-[1.05] transition-all duration-200  ${
                    activeTab === 2
                      ? "border-nemu-azul text-black"
                      : "border-transparent text-nemu-plata"
                  }`}
                >
                  <span>Perfil en Nemu</span>
                </li> */}
                <li
                  onClick={() => setActiveTab(3)}
                  className={`cursor-pointer m-[10px] pb-1 border-b-2 hover:scale-[1.05] transition-all duration-200  ${
                    activeTab === 3
                      ? "border-nemu-azul text-black"
                      : "border-transparent text-nemu-plata"
                  }`}
                >
                  <span>Planes de pagos</span>
                </li>
              </ul>
              <hr className="border-t-1 border-nemu-plata" />
              {activeTab === 1 && (
                <EnterpriseInfo />
              )}
              {/* {activeTab === 2 && (
                <NemuProfile acknowledge={acknowledge} coverPage={coverPage} setCoverPage={setCoverPage}/>
              )} */}
              {activeTab === 3 && (
                <div className="flex flex-col gap-5">
                  <span className="text-sm">Personaliza los planes de pagos para tus desarrollos</span>
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-2">
                      <h1 className="text-xl font-medium ">Planes de pagos</h1>
                      <span className="text-base">Aquí podrás agregar los planes de pagos para tus desarrollos</span>
                    </div>
                    {paymentPlans.length > 0 ?
                      <div>
                      <div className="font-sans">
                      <table className="table-auto w-full">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Nombre</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Descuento</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Pago inicial</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Mensualidad</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">A la entrega</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Meses para pago</th>
                            <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentPlans.map((row, index) => (
                            <tr
                              key={index}
                              className="border-b h-full justify-center items-center border-nemu-plata hover:bg-gray-50"
                            >
                              <td className="px-2 py-2">{row.name}</td>
                              <td className="px-2 py-2">{row.discount}%</td>
                              <td className="px-2 py-2">{row.initialPayment}%</td>
                              <td className="px-2 py-2">{row.monthlyPayment}%</td>
                              <td className="px-2 py-2">{row.giveProperty}%</td>
                              <td className="px-2 py-2">{row.monthsNumber > 0 ? row.monthsNumber : "N/A"}</td>
                              <td className="flex  gap-4 px-2 py-3 text-center items-center">
                                <img src="./assets/Profile/edit_icon.svg" alt="edit" className="cursor-pointer" onClick={handleEdit(row)}/>
                                <img src="./assets/Profile/papericon.svg" alt="paper" className="cursor-pointer" onClick={() => setDeletePlan(row)}/>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  :
                  <div className="flex flex-col gap justify-center w-full h-24">
                    <h1 className="text-xl font-medium">No tienes ningún plan de pago</h1>
                    <p>Agrega tu primer plan para comenzar.</p>
                  </div>  
                  }
                    
                    <div onClick={openModalPPHandler} className="flex w-full items-center mt-4 gap-4 cursor-pointer">
                      <img
                        src="./assets/profile/addIcon.svg"
                        alt="edit"
                        className="h-[2svh]"
                      />
                      <p className="text-[16px] text-nemu-azul font-400">Agregar plan de pagos</p>
                    </div>
                  </div>
                  {openModalPP && <ModalAddPP closeModal={closeModalPPHandler} planToModify={selectedPlan ? selectedPlan : false}/>}
                </div>
              )}
            </div>
          </div>
        )}
        {deletePlan !== null && 
          <Alert onClose={() => setDeletePlan(null)}>
            <div className="flex items-center justify-between gap-3">
              <img src={alertIcon} alt="alert" />
              <h5 className="text-[24px] flex-1">Eliminar {deletePlan.name}</h5>
              <img src={closeIcon} alt="close icon" className="w-6 h-6 rounded-full transition-all duration-300 cursor-pointer hover:rotate-90" onClick={() => setDeletePlan(null)}/>           
            </div>
            <p className="text-[24px]">¿Estás seguro de que deseas eliminar este plan de pago?</p>
            <p className="text-[20px]">Esta acción no se puede deshacer. Si eliminas este plan de pago, toda la información asociada se perderá de forma permanente.</p>
            <div className="flex justify-end w-full gap-2">
              <button onClick={() => setDeletePlan(null)} className="border border-nemu-black px-4 py-2 rounded-md text-[16px] text-black transition-all duration-200 hover:bg-[#E7E7E7]">Cancelar</button>
              <button onClick={() => handleDeletePP(deletePlan.id)} className="bg-[#E72626] px-4 py-2 rounded-md text-[16px] text-white transition-all duration-200 hover:bg-[#D71212]">Eliminar plan</button>
            </div>
          </Alert>
        }
      </div>
    </main>
  );
}

export { Profile };
